/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchDto } from '../../models/branch-dto';

export interface BranchAdminControllerDeleteV1$Params {
  id: string;
}

export function branchAdminControllerDeleteV1(http: HttpClient, rootUrl: string, params: BranchAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BranchDto>> {
  const rb = new RequestBuilder(rootUrl, branchAdminControllerDeleteV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BranchDto>;
    })
  );
}

branchAdminControllerDeleteV1.PATH = '/api/v1/branches/admin/{id}';
